import { createFileRoute } from "@tanstack/react-router";

import { LiveNetworkCanvas } from "@/components/canvas/live-network-canvas";

export const Route = createFileRoute("/$workspace/network")({
  head: () => ({ meta: [{ title: "Network — Dravian Horizon" }] }),
  component: NetworkPage,
});

function NetworkPage() {
  const { workspace } = Route.useParams();
  return <LiveNetworkCanvas workspaceId={workspace} />;
}
